<ul id="sideMenu" class="nav sidebar-menu">
    <li ng-class="{ active: isActive('/customer-account')}">
        <a href="/customer-account">
            <i class="fa fa-building"></i>
            <span>Şirket Bilgileri</span>
        </a>
    </li>
    
    <li ng-class="{ active: isActive('/customer-password')}">
        <a href="/customer-password">
            <i class="fa fa-key"></i>
            <span>Şifre Değiştir</span>
        </a>
    </li>
</ul>